/* eslint-disable prefer-template */
import axios from 'axios';
import ApiEndpoints from '../const/ApiEndpoints';
import SwalToast from '../components/Common/SwalToast';

export default function useSubadmin() {
  const getGroupList = (id, pageIndex = '', pageSize = '', searchText = '') => {
    let params = {};
    if (searchText?.length !== 0 && Number(pageIndex) === 0) {
      params = {
        organization_id: id,
        q: searchText,
        page_size: pageSize,
      };
    } else {
      params = {
        organization_id: id,
        page: pageIndex === '' ? '' : Number(pageIndex) + 1,
        page_size: pageSize,
        q: searchText,
      };
    }
    return axios
      .get(
        `${
          ApiEndpoints.BASE_URL +
          ApiEndpoints.BASE_URL_SUBADMIN +
          ApiEndpoints.GET_SUBADMIN_GROUP_LIST
        }`,
        {
          params: params || {},
        }
      )
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const getAllTenantList = () =>
    axios.get(`${ApiEndpoints.BASE_URL + ApiEndpoints.TENANTS_GET}`).then(
      (res) => {
        return res;
      },
      (error) => {
        throw error;
      }
    );

  const getGroupDetail = (id) => {
    const params = { group_id: id, user_details: true };
    return axios
      .get(
        `${
          ApiEndpoints.BASE_URL +
          ApiEndpoints.BASE_URL_SUBADMIN +
          ApiEndpoints.GET_SUBADMIN_GROUP_LIST
        }`,
        {
          params: params || {},
        }
      )
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const updateGroup = (id, payload) =>
    axios
      .patch(
        `${ApiEndpoints.BASE_URL}${ApiEndpoints.BASE_URL_SUBADMIN}${ApiEndpoints.PATCH_SUBADMIN_GROUP}/${id}`,
        payload
      )
      .then(
        (res) => {
          SwalToast({
            icon: 'success',
            title: 'Group is updated successfully.',
          });
          return res;
        },
        (error) => {
          throw error;
        }
      );

  const getAllUserList = () =>
    axios
      .get(
        `${ApiEndpoints.BASE_URL}${ApiEndpoints.BASE_URL_SUBADMIN}${ApiEndpoints.GET_SUBADMIN_USER_LIST}`
      )
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );

  const getUserList = (pageIndex = '', pageSize = '', searchText = '') => {
    let params = {};
    if (searchText?.length !== 0 && Number(pageIndex) === 0) {
      params = {
        search: searchText,
        page_size: pageSize,
      };
    } else {
      params = {
        page: pageIndex === '' ? '' : Number(pageIndex) + 1,
        page_size: pageSize,
        search: searchText,
      };
    }
    return axios
      .get(`${ApiEndpoints.BASE_URL}${ApiEndpoints.GET_SUBADMIN_USER_LIST}`, {
        params: params || {},
      })
      .then(
        (res) => {
          return res?.data;
        },
        (error) => {
          throw error;
        }
      );
  };

  const createSubadmin = (payload) =>
    axios
      .post(
        `${ApiEndpoints.BASE_URL}${ApiEndpoints.POST_SUBADMIN_USER}`,
        payload
      )
      .then((resp) => {
        SwalToast({
          icon: 'success',
          title: 'Sub-Admin created successfully.',
        });
        return resp.data;
      })
      .catch((error) => {
        throw error;
      });

  const updateSubadmin = (id, payload) =>
    axios
      .put(
        `${ApiEndpoints.BASE_URL}${ApiEndpoints.PATCH_SUBADMIN_USER}${id}/`,
        payload
      )
      .then(
        (res) => {
          SwalToast({
            icon: 'success',
            title: 'Sub-Admin updated successfully.',
          });
          return res;
        },
        (error) => {
          throw error;
        }
      );

  const deteleSubadmin = (id) =>
    axios
      .delete(
        `${ApiEndpoints.BASE_URL}${ApiEndpoints.DELETE_SUBADMIN_USER}${id}/`
      )
      .then(
        (res) => {
          SwalToast({
            icon: 'success',
            title: 'Sub-Admin deleted successfully.',
          });
          return res;
        },
        (error) => {
          throw error;
        }
      );

  /**
   * @description updates the password of a user on the server.
   * @param {object} payload the data payload for updating the user password.
   * @param {number} org_id ID of organization
   * @param {string} user_id ID of the user.
   * @returns {promise} promise that resolves with updating the user password.
   * @example updateSubAdminUserPassword(payload, org_id, user_id)
   */
  const updateSubAdminUserPassword = (payload, userId) =>
    axios
      .patch(
        `${ApiEndpoints.BASE_URL}/user/${ApiEndpoints.RESET_SUB_ADMIN_USER_PASSWORD}${userId}`,
        payload
      )
      .then(
        (res) => {
          SwalToast({
            icon: 'success',
            title: 'User password updated successfully.',
          });
          return res;
        },
        (error) => {
          throw error;
        }
      );

  return {
    getGroupList,
    getAllTenantList,
    getAllUserList,
    getGroupDetail,
    getUserList,
    createSubadmin,
    updateSubadmin,
    updateSubAdminUserPassword,
    deteleSubadmin,
    updateGroup,
  };
}
